let id = 0;

var r: any;
var e: any;

var toFixed2 = (r: any) => r.toFixed(2);
var j = (r: any, e: any) => [e[0] + r[0], e[1] + r[1]];
var I = (r: any, e: any) => [r[0] - e[0], r[1] - e[1]];
var T = (r: any, e: any) => [e * r[0], e * r[1]];

var B = (r: any) => {
    var e = [];
    for (let o = 0; o < r.length; o++) {

        var t;
        var a;

        if (0 == o) {
            t = r[o + 1][0] - r[o][0];
            a = r[o + 1][1] - r[o][1];
        } else {
            t = r[o][0] - r[o - 1][0];
            a = r[o][1] - r[o - 1][1];
        }
        var l = Math.sqrt(Math.pow(t, 2) + Math.pow(a, 2));
        e.push(l);
    }
    var o = [];
    for (let r = 0; r < e.length; r++) {
        var n = Math.max(r - 2, 0);
        var v = Math.min(r + 2 + 1, e.length);
        var i = 0;
        for (let r = n; r < v; r++) {
            i += e[r];
        }
        var u = i / (v - n);
        o.push(u);
    }
    return o;
};

export type RenderType = (a: any, globalHandwritingSize: number) => void;

export const createRenderer = (svgContainer: any) => {
    return (a: any, globalHandwritingSize: number) => {

        var z = (r: any) => {
            for (var e = [], t = 0, a = r.length; t < a;) {
                for (var l = []; t < a && 1 != r[t][2];) {
                    l.push(r[t]);
                    t += 1;
                }
                if (t < a) {
                    l.push(r[t])
                }
                t += 1;
                e.push(l);
            }
            return e;
        };

        var drawStroke = (r: any, handwritingSize: number, t: any) => {

            var a = [];
            var l = [];
            var o = B(r);

            var n;
            var v;

            for (let d = 0; d < r.length; d++) {
                if (d == 0) {
                    n = r[d + 1][0] - r[d][0];
                    v = r[d + 1][1] - r[d][1];
                } else if (d == r.length - 1) {
                    n = r[d][0] - r[d - 1][0];
                    v = r[d][1] - r[d - 1][1];
                } else {
                    n = r[d + 1][0] - r[d - 1][0];
                    v = r[d + 1][1] - r[d - 1][1];
                }

                var i = Math.sqrt(Math.pow(n, 2) + Math.pow(v, 2));
                var u = (i = Math.max(i, 14), o[d] / handwritingSize);
                var f: any = [(f = [t * (f = [-v / i, n / i])[0], t * f[1]])[0] / u, f[1] / u];
                var s = r[d][0] + 2 * f[0];
                var h = r[d][1] + 2 * f[1];

                a.push([s, h]);

                s = r[d][0] - 2 * f[0];
                h = r[d][1] - 2 * f[1];

                l.push([s, h]);
            }

            var d = a.concat(l.reverse());

            var commands = [["M ", toFixed2(d[0][0]), ",", toFixed2(d[0][1])].join("")];

            var p = d.length;

            for (let r = 0; r < p; r++) {
                var w = d[(r - 1 + p) % p];
                var m = d[r];
                var g = d[(r + 1) % p];
                var b = d[(r + 2) % p];
                var M = I(g, w);
                var y = I(b, m);
                var x = j(m, T(M, 0.2));
                var C = I(g, T(y, 0.2));

                var curve = "C " + toFixed2(x[0]) + " " + toFixed2(x[1]) + ", " + toFixed2(C[0]) + " " + toFixed2(C[1]) + ", " + toFixed2(g[0]) + " " + toFixed2(g[1]);

                commands.push(curve);
            }

            var pathCommand = commands.join(" ");

            var path = document.createElementNS("http://www.w3.org/2000/svg", "path");

            path.setAttribute("d", pathCommand);


            // For generating snippets
            if (false) {
                id++;
                path.setAttribute("data-id", `${id}`);
                // @ts-ignore
                console.log(`snippet id=${id} style=${window.globalStyleIdx}`, JSON.stringify(r));
            }

            svgContainer.appendChild(path);

        };

        if (a.length == 0) {
            return;
        }

        var l = 1; // parseFloat(widthSelect.value),
        var o = z(a);

        let n = r || 0;

        for (; n < o.length; n++) {
            a = o[n];

            var canvas = svgContainer;

            if (a.length < 2) {
                if (a.length == 0 || a[0][2] == 1) {
                    r += 1;
                }
            } else {
                if (e && canvas.lastChild) {
                    canvas.removeChild(canvas.lastChild);
                }

                drawStroke(a, globalHandwritingSize, l);

                if (a[a.length - 1][2] == 1) {
                    e = false;
                    r += 1;
                } else {
                    e = true;
                }
            }
        }

    }
}

